
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/bundle-pdp",
      function () {
        return require("private-next-pages/products/bundle-pdp.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/bundle-pdp"])
      });
    }
  